import styled from 'styled-components';
import { Deck } from '@movember/mo-gel';
import { getRGBOpacity, normaliseColor } from '@movember/mo-gel/utils/colors';
import { Heading, Text } from '@movember/mo-gel';

const blurStyling = `
  filter: blur(5px);
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -ms-filter: blur(5px);
  -o-filter: blur(5px);
  filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='5')
`;

export const StyledOutcomesGroupWrapper = styled(Deck)`
  display: flex;
  position: relative;
  flex-direction: column;
  overflow: scroll;
  height: 100%;
  width: 100%;
  position: relative;
  background: white;
  justify-content: center;
  margin: 0;
`;

export const StyledOutcomesGroup = styled.div`
  color: ${(props) => {
    return normaliseColor(props.theme.typography.defaultColors, props.theme) || props.theme.colors.primaryFont;
  }};
  display: flex;
  position: relative;
  flex-direction: column;
  align-self: center;
  width: 100%;
  box-sizing: border-box;
  ${(props) => props.blur && blurStyling}

  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm}) {
    padding: 19px 1.5rem;
    margin-top: -7rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 38px 6.75rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}) {
    padding: 53px 7.85rem;
  }
`;

export const StyledHeadingWrapper = styled.div`
  background-color: ${(props) => getRGBOpacity(props.theme.colors.brandThemeLight100, 0.5)};
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.1rem 1rem;
  text-align: left;
  align-items: flex-start;
  box-sizing: border-box;
  
  color: ${(props) => {
    return normaliseColor(props.theme.typography.defaultColors, props.theme) || props.theme.colors.primaryFont;
  }};
  ${(props) => props.blur && blurStyling}

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    padding: 1.1rem 1.75rem 7rem 1.75rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 1.1rem 6.75rem 7rem 6.75rem;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}) {
    padding: 1.1rem 14.9rem 7rem 14.9rem;
  }
`;

export const StyledHeadingAndLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  border-bottom: 1px solid ${(props) => props.theme.colors.brandThemeLight500};
  margin-bottom: 1.1rem;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }
`;

export const StyledHeading = styled(Heading)`
  width: 228px;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.xs}) {
    width: 332px;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    margin-bottom: 0;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}) {
    width: 433px;
  }
`;

export const StyledLink = styled.a`
  text-decoration: none;
`;

export const StyledLinkText = styled(Text)`
  background-repeat: repeat-x;
  background-image: linear-gradient(
    to right,
    ${(props) => props.theme.colors.actionPrimary300},
    ${(props) => props.theme.colors.actionPrimary300}
  );
  background-size: 1px 0.112em;
  background-position: 0 1.05em;
  background-position: left 0 bottom 1px;
  color: ${(props) => props.theme.colors.brandThemeDark900};
  
  :hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.actionPrimary300};
  }
`;

export const StyledLinkWrapper = styled.div`
  display: flex;
  width: 7rem;
  justify-content: space-between;

  :hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.actionPrimary300};

    svg {
      path:nth-of-type(1) {
        fill: ${(props) => props.theme.colors.actionPrimary300};
      }
    }
  }
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const StyledHeadingTextWrapper = styled.div`
  width: 90%;
  margin-bottom: 0;
  color: ${(props) => {
    return normaliseColor(props.theme.typography.defaultColors, props.theme) || props.theme.colors.primaryFont;
  }};

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    margin-right: 1.5rem;
    margin-bottom: unset;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
    width: 80%;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}) {
    width: 95%;
  }
`;

export const StyledText = styled(Text)`
  width: 98%;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
    margin: 0;
    width: 90%;
  }
`;

export const StyledOutcomesEdit = styled.div`
  background-color: white;
  display: flex;
  width: 50%;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
`;
